import { api } from './client';

export async function generateWorksheet({ learnerId, characterIds, worksheetType = 'stroke_practice', paperSize = 'a4' }) {
  return api.post('/worksheets/generate', {
    child_profile_id: learnerId,
    character_ids: characterIds,
    worksheet_type: worksheetType,
    paper_size: paperSize,
  });
}

export async function getWorksheet(worksheetId) {
  return api.get(`/worksheets/${worksheetId}`);
}

export async function getChildWorksheets(learnerId) {
  return api.get(`/worksheets/child/${learnerId}`);
}

export async function regenerateWorksheet(worksheetId, { paperSize = 'a4' } = {}) {
  return api.post(`/worksheets/${worksheetId}/regenerate`, {
    paper_size: paperSize,
  });
}

export async function markWorksheetComplete(worksheetId) {
  return api.patch(`/worksheets/${worksheetId}/complete`);
}
